div<template>
  <div class="cenario-container">
    <div :class="['bloco-divisao', { 'bloco-multiplo': numeroCenarios > 1 }]">
      <div>
        <div>
          <h3>CNPJ</h3>
          <div class="cenario-cnpj">
            <CenarioInput
              tipo="texto"
              placeholder="Informe o CNPJ"
              mask="##.###.###/####-##"
              :cnpj="confirmaCnpj"
              :model="cnpjRemetente"
              @update:model="update => (cnpjRemetente = update)"
            />
            <BotaoPadrao
              arredondadoDireita
              tipo="icone"
              class="botao-padding"
              icone="search"
              :click="handleCnpj"
              cor="azul"
              padding="51"
              tamanho="15"
              :desabilita="cnpjRemetente.length != 18"
              :tooltip="cnpjRemetente.length != 18 ? 'Preencha o campo de CNPJ' : ''"
            />

            <!-- <button
              class="botao-procura-cnpj"
              @click="verificaCNPJ(id, cnpjRemetente, 'remetente', true)"
            >
              <font-awesome-icon icon="search" />
            </button> -->
          </div>
        </div>
      </div>
      <div>
        <h3>CNAE <span>*</span></h3>
        <CenarioInputCnae
          remetente
          :id="id"
          :calculaDadosForm="calculaDadosForm"
          :calculaDados="calculaDados"
          :dadosForm="dadosForm"
          :filtros="filtros"
          :payloadCnae="payloadCnae"
          :openModalCnaeCompreende="openModalCnaeCompreende"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :elementoCriado="elementoCriado"
          :setAtividadeOptionsRem="setAtividadeOptionsRem"
          :cnaeRemetenteLista="listaCnae.listaCnaeRemetente"
          :cnaeDestinatarioLista="listaCnae.listaCnaeDestinatario"
          :carregandoAlgumaCnae="carregandoAlgumaCnae"
        />
      </div>
      <div v-if="atividadeOptions.length > 1">
        <h3>ATIVIDADE <span>*</span></h3>
        <CenarioInput
          placeholder="Selecione uma Atividade"
          nome="atividadeRemetente"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :model="atividadeRemetente"
          :options="atividadeOptionsLabel"
          @update:model="update => (atividadeRemetente = update)"
          @selected="update => updateDados(update, 'atividadeRemetente', filtros.atividade.valores)"
        />
      </div>
      <div>
        <h3>REGIME TRIBUTÁRIO <span>*</span></h3>
        <CenarioInput
          placeholder="Selecione um Regime Tributário"
          nome="regimeRemetente"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :model="regimeRemetente"
          :options="this.regimeRemetenteOptions"
          @update:model="update => (regimeRemetente = update)"
          @selected="
            update => updateDados(update, 'regimeRemetente', filtros.regime_tributacao.valores)
          "
        />
      </div>
      <div v-if="dadosForm.regimeRemetente == 32 && dadosForm.tipoOperacao != 46">
        <div class="cenario-icone">
          <h3>
            RECEITA BRUTA DOS ÚLTIMOS 12 MESES
          </h3>
          <a
            class="question"
            tabindex="-1"
            target="_blank"
            href="http://www.econeteditora.com.br/bdi/lei/06/lei123_complementar_2006.asp#art18_p1"
          >
            <font-awesome-icon
              class="btn-question"
              v-b-tooltip.hover
              title="Informe a receita bruta total acumulada nos 12 meses anteriores ao do período de apuração (Lei Complementar nº 123/2006, artigo 18, § 1º)."
              icon="question-circle"
            />
          </a>
        </div>

        <CenarioInput
          dinheiro
          tipo="texto"
          :model="dadosForm.sn_rbt12"
          @update:model="update => calculaDadosForm(update, 'sn_rbt12')"
        />
      </div>
      <div v-if="dadosForm.regimeRemetente == 32 && dadosForm.tipoOperacao != 46">
        <div class="cenario-icone">
          <h3>RECEITA ACUMULADA (ANO-CALENDÁRIO)</h3>
          <div class="question">
            <font-awesome-icon
              class="btn-question"
              v-b-tooltip.hover
              title="Informe a receita bruta acumulada (pelo regime de competência) auferida desde o mês de Janeiro, incluindo-se neste valor a receita do mês de apuração."
              icon="question-circle"
            />
          </div>
        </div>
        <CenarioInput
          dinheiro
          tipo="texto"
          nome="sn_rba"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :model="dadosForm.sn_rba"
          @update:model="update => calculaDadosForm(update, 'sn_rba')"
        />
      </div>
      <div v-if="dadosForm.regimeRemetente == 32 && dadosForm.tipoOperacao != 46">
        <div class="cenario-icone">
          <h3>RECEITA DO MÊS (MÊS CORRENTE)</h3>
          <div class="question">
            <font-awesome-icon
              class="btn-question"
              v-b-tooltip.hover
              title="Informe a receita bruta do mês (pelo regime de competência)."
              icon="question-circle"
            />
          </div>
        </div>
        <CenarioInput
          dinheiro
          tipo="texto"
          nome="sn_rm"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :model="dadosForm.sn_rm"
          @update:model="update => calculaDadosForm(update, 'sn_rm')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CenarioInput from "../CenarioInput/CenarioInput.vue";
import AlertaCenario from "./AlertaCenario.vue";
import CenarioInputCnae from "./CenarioInputCnae.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";

import { mapGetters } from "vuex";

export default {
  name: "CenarioCorpoRemetente",

  components: { CenarioInput, AlertaCenario, CenarioInputCnae, BotaoPadrao },

  props: {
    impedimentoSnRes: Boolean,
    elementoCriado: Boolean,
    carregandoAlgumaCnae: Boolean,
    exibeValidacao: Boolean,
    id: Number,
    numeroCenarios: Number,
    calculaDadosForm: Function,
    calculaDados: Function,
    verificaCNPJ: Function,
    openModalCnaeCompreende: Function,
    dadosForm: Object,
    filtros: Object,
    payloadCnae: Object,
    validaCampos: Object,
    listaCnae: Object
  },

  data() {
    return {
      cnpjRemetente: "",
      atividadeRemetente: "",
      regimeRemetente: "",
      atividadeOptions: []
    };
  },

  created() {
    this.cnpjRemetente = this.dadosForm.cnpjRemetente;
  },

  beforeDestroy() {
    this.calculaDadosForm("", "regimeRemetente");
    this.calculaDadosForm("R$ 0,00", "sn_rbt12");
    this.calculaDadosForm("R$ 0,00", "sn_rba");
    this.calculaDadosForm("R$ 0,00", "sn_rm");
  },

  watch: {
    // ZERA O VALOR DE CNPJ REMETENTE DO FORMULÁRIO QUANDO INPUT NÃO TEM VALOR
    cnpjRemetente() {
      if (this.cnpjRemetente.length == 0) {
        this.calculaDadosForm("", "cnpjRemetente");
      }
    },
    // REINICIA VALORES BASEANDO-SE NO TIPO DE OPERAÇÃO
    "dadosForm.tipoOperacao": {
      deep: true,
      handler() {
        if (this.dadosForm.tipoOperacao == 41) {
          this.$nextTick(() => {
            this.calculaDadosForm("", "regimeRemetente");
            this.calculaDadosForm("R$ 0,00", "sn_rbt12");
            this.calculaDadosForm("R$ 0,00", "sn_rba");
            this.calculaDadosForm("R$ 0,00", "sn_rm");
          });
        }
        if (this.dadosForm.tipoOperacao == 46) {
          this.$nextTick(() => {
            this.calculaDadosForm("R$ 0,00", "sn_rbt12");
            this.calculaDadosForm("R$ 0,00", "sn_rba");
            this.calculaDadosForm("R$ 0,00", "sn_rm");
          });
        }
      }
    },
    // ESCREVE NO INPUT VALOR DE CNPJ QUANDO ESTÁ NO FORMULÁRIO
    "dadosForm.cnpjRemetente": {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.cnpjRemetente = this.dadosForm.cnpjRemetente;
        });
      }
    },

    // ZERA VALORES DE SIMPLES QUANDO ALTERA O REGIME
    "dadosForm.regimeRemetente": {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.calculaDadosForm("R$ 0,00", "sn_rbt12");
          this.calculaDadosForm("R$ 0,00", "sn_rba");
          this.calculaDadosForm("R$ 0,00", "sn_rm");
        });
      }
    },
    // ESCREVE NOS INPUTS O VALOR DO FORMULÁRIO QUANDO ALTERADO
    dadosForm: {
      deep: true,
      handler() {
        this.carregaDadosForm();
      }
    }
  },

  computed: {
    ...mapGetters("empresa", ["getEmpresa"]),
    // TOOLTIP E INDICADOR DO ÍCONE DE CNPJ REMETENTE NO INPUT
    confirmaCnpj() {
      if (
        this.cnpjRemetente == this.dadosForm.cnpjRemetente &&
        this.dadosForm.cnpjRemetente != ""
      ) {
        return {
          status: "confirma",
          titulo: `CNPJ: ${this.dadosForm.cnpjRemetente} - Lista de CNAEs com base no CNPJ descrito.`
        };
      } else if (
        this.cnpjRemetente != this.dadosForm.cnpjRemetente &&
        this.dadosForm.cnpjRemetente != ""
      ) {
        return {
          status: "alerta",
          titulo: `CNPJ: ${this.dadosForm.cnpjRemetente} - Lista de CNAEs com base no CNPJ descrito.`
        };
      } else if (
        (this.dadosForm.cnpjRemetente == "" && this.getEmpresa && this.getEmpresa.cnpj) ||
        (this.cnpjRemetente != this.dadosForm.cnpjRemetente &&
          this.getEmpresa &&
          this.getEmpresa.cnpj)
      ) {
        return {
          status: "alerta",
          titulo: `CNPJ: ${this.getEmpresa.cnpj} - Lista de CNAEs com base na empresa cadastrada.`
        };
      } else if (this.dadosForm.cnpjRemetente == "") {
        return {
          status: "vazio",
          titulo: `Preencha o CNPJ e confirme no botão ao lado, ou selecione uma empresa cadastrada.`
        };
      }
    },
    // RETORNA AS OPÇÕES DE ATIVIDADE
    atividadeOptionsLabel() {
      if (this.atividadeOptions.length > 1) {
        let options = [];
        this.atividadeOptions.forEach((p, i) => {
          let label = this.filtros.atividade.valores.find(f => f.value == p).label;
          options[i] = label;
        });
        return options;
      }
      return [];
    },
    // RETORNA AS OPÇÕES DO REGIME REMETENTE
    regimeRemetenteOptions() {
      let regimeOpcoes = this.impedimentoSnRes ? ["30", "31"] : ["30", "31", "32"];
      let options = this.filtros.regime_tributacao.valores.filter(p =>
        regimeOpcoes.some(x => x == p.value)
      );
      return options.map(p => p.label);
    }
  },

  methods: {
    async handleCnpj() {
      const response = await fetch('https://ecohub-vendas.econeteditora.com.br/api/leads/rte', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tipoConsulta: 'cnpj', dados: { cnpj: this.cnpjRemetente } })
      });
      const data = await response.json();
      if (data.status === 200) {
        // Preenche CNPJ no formulário
        this.calculaDadosForm(this.cnpjRemetente, "cnpjRemetente");

        // Aguarda a lista carregar e preenche o CNAE principal pelo ID
        setTimeout(() => {
          const cnae = data.data.cnaePrincipalCodigo;
          if (cnae && cnae.length === 7) {
            const cnaeFormatado = cnae.substring(0, 4) + '-' + cnae.substring(4, 5) + '/' + cnae.substring(5, 7);

            // Busca o ID da CNAE na lista carregada
            const cnaeEncontrada = this.listaCnae.listaCnaeRemetente.find(item =>
              item.label && item.label.startsWith(cnaeFormatado)
            );

            if (cnaeEncontrada) {
              this.calculaDadosForm(cnaeEncontrada.value, 'cnaeRemetente');
            }
          }
        }, 1000);

        // Preenche regime tributário automaticamente
        const regimeMap = {
          'LUCRO PRESUMIDO': '30',
          'LUCRO REAL': '31',
          'SIMPLES NACIONAL': '32'
        };
        const regimeId = regimeMap[data.data.regimeTributario];
        if (regimeId) {
          this.calculaDadosForm(regimeId, 'regimeRemetente');
        }
      }
    },
    // ATUALIZA O FORMULÁRIO DE ACORDO COM OS VALORES LOCAIS
    updateDados(update, campo, caminho) {
      this[campo] = update;
      let valor = caminho.find(p => p.label == update);
      this.calculaDadosForm(valor ? valor.value : "", campo);
    },
    // ESCREVE OS VALORES DOS INPUTS DE ACORDO COM O FORMULÁRIO
    carregaDadosForm() {
      let dados = [
        // { valor: "cnaeRemetente", filtro: this.listaCnae },
        { valor: "regimeRemetente", filtro: this.filtros.regime_tributacao.valores },
        { valor: "atividadeRemetente", filtro: this.filtros.atividade.valores }
      ];
      dados.forEach(p => {
        this.carregaValor(p.valor, p.filtro);
      });
    },
    // FUNÇÃO CHAMADA PARA ESCREVER OS VALORES LOCAIS
    carregaValor(valor, filtro) {
      let resultado = filtro.find(p => p.value == this.dadosForm[valor]);
      this[valor] = resultado ? resultado.label : "";
    },
    // FUNÇÃO PASSADA POR PROPS PARA ESCREVER AS OPÇÕES ATIVIDADE DE ACORDO COM CNAE
    setAtividadeOptionsRem(atividades) {
      this.atividadeOptions = atividades;
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-family: "Open Sans";
  font-weight: bold;
  font-size: 11px;
  text-transform: uppercase;
  color: #9ea2a7;
  span {
    color: red;
  }
}
.cenario-container {
  margin: 0.5rem 0;
}

.cenario-bloco {
  margin-top: 10px;
}
.botao-procura-cnpj {
  border-radius: 0 50px 50px 0;
  padding: 3px 45px;
  margin-left: 10px;
  background: var(--azul4);
  color: var(--branco);
  white-space: nowrap;
  transition: background 0.3s ease;
  &:hover {
    text-decoration: none;
    background: var(--azul2);
  }
  &:focus {
    background: #25beff;
  }
}
.cenario-cnpj {
  display: flex;
}
.question {
  color: #666;
  display: flex;
  align-items: center;
  user-select: none;
}
.btn-question {
  margin-left: 5px;
  font-size: 13px;
}
.cenario-icone {
  display: flex;
  align-items: flex-start;
}
</style>
